import getLabelsById from '../../getLabelsById';

import options from './options';

export default getLabelsById(options);
